import { useCallback, useState } from 'react';
import CountryFormComponent from '../components/country-form.component';
import { CountryCreate, CountryUpdate } from '../types/country.types';
import { useCountryCreate } from '../hooks/use-country.hook';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  extractCreateError,
  extractValidationError,
} from '../../../../../services/extract-api-error.service';
import HeaderRow from '../../../../common/HeaderRow';
import { ValidationError } from '../../../../../types/api-response.types';
import { useTranslation } from 'react-i18next';
import { WithSysAdminPermissionCheck } from '@components/auth/WithSysAdminPermissionCheck';
import PageTitle from '@components/common/PageTitle';

const CountryCreateContainer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [validationErrors, setValidationErrors] = useState<ValidationError[]>([]);

  const { mutateAsync: createCountry, isPending } = useCountryCreate();

  const onFormSubmit = useCallback(
    async (data: CountryCreate | CountryUpdate, resetForm: () => void) => {
      // Reset validation errors on new submission
      setValidationErrors([]);

      // For create operations, we know we'll have all required fields
      const createData = data as CountryCreate;
      try {
        const response = await createCountry(createData);
        message.success(t('crud.create.success', { entity: t('countries.title') }));
        resetForm();
        navigate(`/dashboard/admin/country/${response.data.id}/update`);
      } catch (error: any) {
        const errorFields = extractValidationError(error);
        setValidationErrors(errorFields);
        const errorMessage = extractCreateError(
          error,
          t('crud.create.error', { entity: t('countries.title') })
        );
        message.error(errorMessage);
      }
    },
    [createCountry, navigate, t]
  );

  return (
    <>
      <PageTitle title={t('crud.create.title', { entity: t('countries.title') })} />
      <HeaderRow
        title={t('crud.create.title', { entity: t('countries.title') })}
        showBackButton={true}
        isSysAdmin={true}
      />
      <div className="row mt-3">
        <CountryFormComponent
          onFormSubmit={onFormSubmit}
          isLoading={isPending}
          columns={3}
          validationErrors={validationErrors}
        />
      </div>
    </>
  );
};

export default WithSysAdminPermissionCheck(CountryCreateContainer, 'country.create');
